// extracted by mini-css-extract-plugin
module.exports = {"searchInputWithDropdown":"search-input-with-dropdown_searchInputWithDropdown__ftcG_","dropdownWrapper":"search-input-with-dropdown_dropdownWrapper__j7QLw"};